import React from 'react';
import PropTypes from 'prop-types';

import Grid from '../../Grid';

const propTypes = {
  name: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  renderValue: PropTypes.func,
  data: PropTypes.shape(),
};
const defaultProps = {
  valueSuffix: null,
};

const TextGroup = ({ name, value, renderValue, data }) => (
  <Grid xs={2} gap={6}>
    <div>
      <b>{name}</b>
    </div>
    <div className="break-words">
      {renderValue && !!data ? renderValue({ value, data }) : <b>{value}</b>}
    </div>
  </Grid>
);

TextGroup.propTypes = propTypes;
TextGroup.defaultProps = defaultProps;

export default TextGroup;
